import type { RouteObject } from "react-router-dom";

import { AdminPage } from "./admin/AdminPage";
import { ProfilePage } from "./profile/ProfilePage";
import "./review_admin.css";

/**
 * F05 web_review_admin: my profile and the admin page (BUILD-PLAN 2.11.2). Who may open each path is in `app/screens.ts`; the
 * server checks the role again on every request. The SME inbox and card, the back-from-SME lane and the older getting started
 * are replaced by the Review and Getting started views, and their addresses open those views (`MOVED_SCREENS` in
 * `app/screens.ts`). Their blocks and hooks stay here, and the Review view uses them.
 */
export const routes: RouteObject[] = [
  { path: "/profile", element: <ProfilePage /> },
  { path: "/admin", element: <AdminPage /> },
];
